import { OrthographicCamera, Vector2, Vector3 } from "three";

export const CAMERA_YAW = Math.PI / 4;
export const CAMERA_PITCH = (40 * Math.PI) / 180;
export const CAMERA_DISTANCE = 96;
export const CAMERA_LOOK_Y = 0.35;

export function cameraPanAxes(yaw = CAMERA_YAW) {
  return {
    downX: Math.sin(yaw),
    downZ: Math.cos(yaw),
    rightX: Math.cos(yaw),
    rightZ: -Math.sin(yaw),
  };
}

export function cameraOffset(yaw = CAMERA_YAW, pitch = CAMERA_PITCH) {
  const horizontal = Math.cos(pitch) * CAMERA_DISTANCE;
  return new Vector3(
    Math.sin(yaw) * horizontal,
    Math.sin(pitch) * CAMERA_DISTANCE,
    Math.cos(yaw) * horizontal,
  );
}

export function placeCamera(
  camera: OrthographicCamera,
  pan: Vector2,
  yaw = CAMERA_YAW,
) {
  const offset = cameraOffset(yaw);
  camera.position.set(pan.x + offset.x, offset.y, pan.y + offset.z);
  camera.lookAt(pan.x, CAMERA_LOOK_Y, pan.y);
  camera.updateMatrixWorld();
}
